/* eslint-disable camelcase */
/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Sentry from '../../lib/sentry';
import EstimationForm from './estimation/EstimationForm';
import Footer from './common/Footer';
import { companyInfoPropsType, getPricings } from '../helpers/fetchCmsContent';
import { scrollToElement } from '../helpers/scrollToElement';
import ClarityService from '../helpers/clarity';

const formConvertObjectToString = (objElem) => {
    if (objElem === undefined || objElem === null) {
        return 'brak danych';
    }
    return Object.keys(objElem).filter((key) => objElem[key]).join(', ');
};

class Estimation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formType: 'LemlockContactForm',
            radioButton: '',
            improve: null,
            decrease: null,
            name: '',
            email: '',
            phone: '',
            message: '',
            agreement_data: false,
            agreement_marketing: false,
            agreement_rodo: false,
            sending: false,
            error: {
                name: false,
                email: false,
                phone: false,
                message: false,
                agreement_data: false,
                agreement_marketing: false,
                agreement_rodo: false
            },
            responseType: null,
            errorType: null,
            pricings: []
        };
        this.handleChangeRadio = this.handleChangeRadio.bind(this);
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRecaptchaError = this.handleRecaptchaError.bind(this);
        this.handleServerError = this.handleServerError.bind(this);
        this.fetchPricings = this.fetchPricings.bind(this);

        this.isFirstLoad = false;
        this.reCaptchaRef = createRef();
    }

    componentWillMount() {
        this.setState(this.initialState());
    }

    componentDidMount() {
        this.fetchPricings();

        this.isFirstLoad = true;
    }

    componentDidUpdate(prevProps) {
        if (this.props.preloaderDone !== prevProps.preloaderDone && this.props.preloaderDone === true) {
            if (this.isFirstLoad && this.state.radioButton === '') {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                this.isFirstLoad = false;
            } else if (this.isFirstLoad && this.state.radioButton !== '') {
                scrollToElement('pricing-scroll');
                this.isFirstLoad = false;
            }
        }
    }

    initialState() {
        const { t } = this.props;

        const improve = {};
        t('estimation.improve').forEach((section) => {
            improve[section.slug] = {};
            section.option.forEach((elem) => {
                improve[section.slug][elem.slug] = false;
            });
        });

        const decrease = {};
        t('estimation.decrease').forEach((section) => {
            decrease[section.slug] = {};
            section.option.forEach((elem) => {
                decrease[section.slug][elem.slug] = false;
            });
        });

        return {
            radioButton: '',
            improve,
            decrease,
            name: '',
            email: '',
            phone: '',
            message: '',
            agreement_data: false,
            agreement_marketing: false,
            agreement_rodo: false,
            error: {
                name: false,
                email: false,
                message: false,
                agreement_data: false,
                agreement_marketing: false,
                agreement_rodo: false
            },
            responseType: null,
            errorType: null
        };
    }

    async fetchPricings() {
        const pricings = await getPricings(this.props.language);
        this.setState({ pricings });
        const searchParams = new URLSearchParams(window.location.search);
        this.setState({ radioButton: searchParams.get('pricing') || '' });
    }

    handleRecaptchaError() {
        this.setState({ responseType: 'error', errorType: 'recaptcha_error' });
    }

    handleServerError() {
        this.setState({ responseType: 'error', errorType: 'server_error' });
    }

    handleChangeRadio(e) {
        this.setState({ radioButton: e.target.value, responseType: null });
    }

    handleChangeCheckbox(part, section) {
        return (e) => {
            this.setState({
                [part]: {
                    ...this.state[part],
                    [section]: {
                        ...this.state[part][section],
                        [e.target.name]: e.target.checked
                    }
                }
            });
        };
    }

    handleChange(e) {
        switch (e.target.type) {
            case 'checkbox': {
                this.setState({ [e.target.name]: e.target.checked });
                break;
            }
            case 'textarea': {
                this.setState({ [e.target.name]: e.target.value.substring(0, 10000) });
                break;
            }
            default: {
                this.setState({ [e.target.name]: e.target.value });
                break;
            }
        }
    }

    async handleSubmit(e) {
        e.preventDefault();
        let params = {};
        if (window.location.search !== '') {
            params = JSON.parse(`{"${
                decodeURI(window.location.search.substring(1))
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"')
            }"}`);
        }

        const { language } = this.props;
        const {
            radioButton, improve, decrease, name, email, phone, message, agreement_data, agreement_marketing, agreement_rodo
        } = this.state;

        let errorAll = false;
        const error = {
            name: false,
            email: false,
            agreement_data: false,
            agreement_marketing: false,
            agreement_rodo: false
        };

        error.radioButton = !radioButton;
        errorAll = errorAll || error.radioButton;

        error.name = (name === '');
        errorAll = errorAll || error.name;

        const emailRegExp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/; // eslint-disable-line max-len
        error.email = !emailRegExp.test(email);
        errorAll = errorAll || error.email;

        error.agreement_data = !agreement_data;
        errorAll = errorAll || error.agreement_data;

        error.agreement_rodo = !agreement_rodo;
        errorAll = errorAll || error.agreement_rodo;

        this.setState({ error });

        let token = '';

        if (errorAll === false && this.state.sending === false) {
            token = await this.reCaptchaRef.current.executeAsync();
        }

        if (errorAll === false && this.state.sending === false && token !== '' && token !== '') {
            this.setState({ sending: true }, () => {
                axios({
                    method: 'post',
                    url: process.env.OPPORTUNITY,
                    data: {
                        form_name: 'Formularz wyceny',
                        type: this.state.formType,
                        improve: radioButton === 'improve' ? Object.entries(improve).map((imp) => formConvertObjectToString(imp[1])).filter((v) => v !== '').join(', ') : 'brak danych',
                        decrease: radioButton === 'decrease' ? Object.entries(decrease).map((dec) => formConvertObjectToString(dec[1])).filter((v) => v !== '').join(', ') : 'brak danych',
                        name: name.substring(0, 50),
                        email: email.substring(0, 100),
                        phone: phone.substring(0, 20),
                        message: message.substring(0, 10000),
                        agreement_data,
                        agreement_marketing,
                        agreement_rodo,
                        language,
                        clarity_project_id: ClarityService.getProjectId(),
                        session_id: sessionStorage.getItem('session_id'),
                        recaptcha: token,
                        referrer: document.referrer,
                        ...params
                    },
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                    .then((response) => {
                        ClarityService.setCorrelationId(response);
                        ClarityService.setCustomAttributes(window.location.pathname);
                        if (response.data && response.data.success) {
                            this.setState({
                                ...this.initialState(),
                                radioButton,
                                responseType: 'success'
                            });
                        } else {
                            this.setState({
                                error: {
                                    name: !!response.data.error_name,
                                    email: !!response.data.error_email,
                                    phone: !!response.data.error_phone,
                                    message: !!response.data.error_message,
                                    agreement_data: !!response.data.error_agreement_data,
                                    agreement_marketing: !!response.data.error_agreement_marketing,
                                    agreement_rodo: !!response.data.error_agreement_rodo
                                },
                                responseType: 'error',
                                errorType: response.data.error
                            });
                        }
                    })
                    .catch((err) => {
                        Sentry.captureException(err);
                        const { response } = err;
                        if (response.data.error === 'RECAPTCHA_LOW_SCORE' || 'RECAPTCHA_VALIDATION_ERROR') {
                            this.handleRecaptchaError();
                        } else {
                            this.handleServerError();
                        }
                        axios({
                            method: 'post',
                            url: process.env.OPPORTUNITY,
                            data: {
                                form_info: JSON.stringify({
                                    form_name: 'Formularz wyceny',
                                    type: this.state.formType,
                                    improve: radioButton === 'improve' ? Object.entries(improve).map((imp) => formConvertObjectToString(imp[1])).filter((v) => v !== '').join(', ') : 'brak danych',
                                    decrease: radioButton === 'decrease' ? Object.entries(decrease).map((dec) => formConvertObjectToString(dec[1])).filter((v) => v !== '').join(', ') : 'brak danych',
                                    name: name.substring(0, 50),
                                    email: email.substring(0, 100),
                                    phone: phone.substring(0, 20),
                                    message: message.substring(0, 10000),
                                    agreement_data,
                                    agreement_marketing,
                                    agreement_rodo,
                                    language,
                                    recaptcha: token,
                                    referrer: document.referrer,
                                    ...params
                                })
                            },
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest'
                            }
                        });
                    })
                    .finally(() => {
                        if (this.reCaptchaRef) this.reCaptchaRef.current.reset();
                        this.setState({ sending: false });
                    });
            });
        } else {
            this.setState({ responseType: 'error', errorType: 'general_error' });
        }
    }

    render() {
        const {
            radioButton, improve, decrease, responseType, errorType, error
        } = this.state;
        const {
            t, openPage, language, consents, companyInfo
        } = this.props;
        return (
            <div className="page-estimation">
                <div className="estimation-header">
                    <h2 className="estimation-header-title">{ t('estimation.header.main') }</h2>
                </div>
                <EstimationForm
                  t={ t }
                  improve={ improve }
                  decrease={ decrease }
                  improveSlug="improve"
                  decreaseSlug="decrease"
                  radioButton={ radioButton }
                  handleSubmit={ this.handleSubmit }
                  handleChangeRadio={ this.handleChangeRadio }
                  handleChangeCheckbox={ this.handleChangeCheckbox }
                  handleChange={ this.handleChange }
                  name={ this.state.name }
                  email={ this.state.email }
                  phone={ this.state.phone }
                  message={ this.state.message }
                  agreement_data={ this.state.agreement_data }
                  agreement_marketing={ this.state.agreement_marketing }
                  agreement_rodo={ this.state.agreement_rodo }
                  error={ error }
                  responseType={ responseType }
                  errorType={ errorType }
                  consents={ consents }
                  sending={ this.state.sending }
                  pricings={ this.state.pricings }
                  language={ language }
                  ref={ this.reCaptchaRef }
                />
                <Footer t={ t } openPage={ openPage } language={ language } claim={ this.props.claim } companyInfo={ companyInfo }/>
            </div>
        );
    }
}

Estimation.defaultProps = {
    companyInfo: null
};
Estimation.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    preloaderDone: PropTypes.bool.isRequired,
    consents: PropTypes.objectOf(Object).isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default Estimation;




// WEBPACK FOOTER //
// ./src/components/content/Estimation.jsx